<mat-card [class.appearance-flat]="appearance() === 'flat'">
  @if (data.label || data.description) {
    <mat-card-header>
      <mat-card-title
        [class.error]="error.isErrorState()"
        [class.required]="required()"
        [id]="id"
        [innerHTML]="data.label"
      ></mat-card-title>

      @if (data.labelInfo) {
        <mat-card-subtitle>{{ data.labelInfo }}</mat-card-subtitle>
      }

      @if (data.description) {
        <ui-form-description-toggle [(open)]="descriptionOpen" alignment="label"></ui-form-description-toggle>
      }
    </mat-card-header>
  }

  <mat-card-content>
    @if (data.description && descriptionOpen()) {
      <ui-form-description-panel [description]="data.description"></ui-form-description-panel>
    }

    <mat-list
      class="options-list"
      [class.error]="error.isErrorState()"
      [control]="control"
      [data]="data"
      uiFormInputValidators
    >
      @for (item of items(); track item.key) {
        <!-- a list item has no `disabled` input, its state class enables the disabled list tokens -->
        <mat-list-item
          [class.mdc-list-item--disabled]="disabled()"
          [lines]="item.description ? 3 : 1"
        >
          <span matListItemIcon>
            @if (multiple()) {
              <mat-checkbox
                (change)="onSelectionChange(item.key, $event.checked)"
                [checked]="item.selected"
                [disabled]="disabled()"
                [id]="item.toggleId"
                color="primary"
              ></mat-checkbox>
            } @else {
              <mat-radio-button
                (change)="onSelectionChange(item.key, true)"
                [checked]="item.selected"
                [disabled]="disabled()"
                [id]="item.toggleId"
                [name]="id"
                [required]="data.attributes?.required ?? false"
                [value]="item.key"
                color="primary"
              ></mat-radio-button>
            }
          </span>
          <label matListItemTitle [for]="item.toggleInputId">{{ item.label }}</label>
          @if (item.description) {
            <span>{{ item.description }}</span>
          }
        </mat-list-item>
      }
    </mat-list>

    @if (data.hint && !error.isErrorState()) {
      <mat-hint [innerHtml]="data.hint"></mat-hint>
    }

    <mat-error
      #error="uiFormError"
      [control]="control"
      [data]="data"
      uiFormError
    ></mat-error>
  </mat-card-content>
</mat-card>
